/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_TitleInputs */

const en_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultivate the state you want to grow`)
};

const ar_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عزز الحالة الذهنية التي تريد تنميتها`)
};

const de_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kultiviere den Geisteszustand, den du fördern möchtest`)
};

const es_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultiva el estado mental que deseas ver crecer`)
};

const fr_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultivez l'état d'esprit que vous souhaitez faire grandir`)
};

const it_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coltiva lo stato d'animo che desideri far crescere`)
};

const ja_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`育てたい心の状態を育みましょう`)
};

const ko_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`성장시키고 싶은 마음의 상태를 가꾸세요`)
};

const pt_br_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultive o estado de espírito que você deseja desenvolver`)
};

const ru_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Взращивайте состояние, которое хотите развить`)
};

const th_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพาะบ่มสภาวะจิตใจที่คุณต้องการให้เติบโต`)
};

const tr_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliştirmek istediğin ruh halini besle`)
};

const zh_cn_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每一份专注都有元素加持，种出你的开运森林。`)
};

const zh_tw_daily_paywall_exclusive_tree_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每一份專注都有元素加持，種出你的開運森林。`)
};

/**
* | output |
* | --- |
* | "Cultivate the state you want to grow" |
*
* @param {Daily_Paywall_Exclusive_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_title = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_title(inputs)
	return zh_tw_daily_paywall_exclusive_tree_title(inputs)
});